
export default {
  name: 'EmptyPlug',
  data() {
    return {
      i18n: 'pages.education.courses-list'
    }
  }
}
